import "./usersTable.css";
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import listUsers from "../methods/api/listUsers";
import { UsersContext } from "../contextProviders/UsersProvider";
import {
  AiOutlineDelete,
  AiOutlineClose,
  AiOutlineUserAdd,
} from "react-icons/ai";
import { confirmAlert } from "react-confirm-alert";
import deleteUser from "../methods/api/deleteUser";
import AddNewUser from "./AddNewUser";

const UsersTable = ({}) => {
  const { users, setUsers, filteredUsers, setFilteredUsers } =
    useContext(UsersContext);
  const fetchUsersList = () => {
    listUsers().then((response) => {
      setUsers(response || []);
      setFilteredUsers(response || []);
    });
  };
  useEffect(() => {
    fetchUsersList();
  }, []);

  const filterUsers = () => {
    setFilteredUsers(
      users.filter(
        (user) =>
          user.username
            ?.toUpperCase()
            .includes(
              document.getElementById("formSearchbox").value.toUpperCase()
            ) ||
          (user.role === "admin" ? "administrator" : "użytkownik")
            .toUpperCase()
            .includes(
              document.getElementById("formSearchbox").value.toUpperCase()
            )
      )
    );
  };

  return (
    <main>
      <h2 className="subpage-title">LISTA UŻYTKOWNIKÓW</h2>
      <div className="table-wrapper">
        <AddNewUser fetchUsersList={fetchUsersList} />
        <input
          id="formSearchbox"
          placeholder="Proszę zacząć wpisywać nazwę lub rolę w celu wyszukania użytkownika..."
          onInput={() => {
            filterUsers();
          }}
        />
        <table className="fl-table users-table">
          <thead>
            <tr>
              <th>L.p.</th>
              <th>Nazwa użytkownika</th>
              <th>Rola</th>
              <th>Usuń</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers
              ?.slice(0)
              .reverse()
              .map((user, index) => (
                <TableRow user={user} index={index} />
              ))}
          </tbody>
        </table>
      </div>
    </main>
  );
};

export default UsersTable;

const TableRow = ({ user, index }) => {
  const { users, setUsers, filteredUsers, setFilteredUsers } =
    useContext(UsersContext);

  const navigate = useNavigate();
  const [deleteIcon, setDeleteIcon] = useState(
    <AiOutlineDelete className="row-delete-icon" />
  );

  const handleDelete = (user) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="confirmation-modal-backdrop">
            <div className="confirmation-modal-content">
              <h1 className="modal-title">
                Usunąć użytkownika <b>{user.username}</b>?
              </h1>
              <p className="modal-message">Ta operacja jest nieodwracalna</p>
              <div className="modal-buttons">
                <button
                  className="modal-button modal-button-no"
                  onClick={onClose}
                >
                  NIE
                </button>
                <button
                  className="modal-button modal-button-yes"
                  onClick={() => {
                    deleteUser(user.username).then((status) => {
                      if (status === 200) {
                        listUsers().then((response) => {
                          setUsers(response);
                          setFilteredUsers(response);
                        });
                      } else {
                        if (status === 403) {
                          alert("Niedozwolona operacja!")
                        }
                        setDeleteIcon(
                          <AiOutlineClose className="fade-out" color="red" />
                        );
                      }
                      setTimeout(
                        () =>
                          setDeleteIcon(
                            <AiOutlineDelete className="row-delete-icon" />
                          ),
                        2000
                      );
                    });
                    onClose();
                  }}
                >
                  TAK
                </button>
              </div>
            </div>
          </div>
        );
      },
    });
  };

  return (
    <tr>
      <td>{users.length - index}.</td>
      <td>{user.username}</td>
      <td>{user.role === "admin" ? "administrator" : "użytkownik"}</td>
      <td>
        <button
          className={"delete-row-button"}
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(user);
          }}
        >
          {deleteIcon}
        </button>
      </td>
    </tr>
  );
};
